import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import "react-phone-input-2/lib/style.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import AdminLoader from "../../components/common/loader/AdminLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch, useSelector } from "react-redux";
import { fetchServiceTypes } from "../../store/slices/serviceTypesSlice";
import { fetchLeadTypes } from "../../store/slices/leadTypeSlice";
import { fetchGroups } from "../../store/slices/groupSlice";
import { fetchSources } from "../../store/slices/sourceSlice";
import { fetchStatus } from "../../store/slices/statusSlice";
import { fetchEmployees } from "../../store/slices/employeeAdminSlice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { fetchLeads, addLead } from "../../store/slices/leadsSlice";
import {
  setcurrentLeadID,
  setCurrentPageTitle,
} from "../../store/slices/pageSlice";
import FileUploadAddLead from "./FileUploadAddLead";
import { uploadFile } from "../../store/slices/FileDataSlice";
import { fetchCompanyProfiles } from "../../store/slices/companyProfileSlice";
import { resolveCountryInputConfig, useCurrencySymbol } from "../../utils/currencyUtils";
import { useLoggedUser } from "../../utils/useLoggedUser";
import DateConversion from "../../utils/DateConversion";
import CommaConvert from "../../utils/CommaConvert";
import Multipleleadexport from "./Multipleleadexport";
import {
  deleteLeadId,
  generateLeadId,
} from "../../store/slices/lead/leadIdGenerationSlice";
import { getFeatureAccessLevel } from "../../utils/featureAccessUtils";
import { fetchSalesHourlyRates } from "../../store/slices/salesHourlyRateSlice";

const AddLead = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const currency = useCurrencySymbol();
  const { getDatePlaceholder, getDateFormat } = DateConversion();
  const USAComma = CommaConvert();
  const dispatch = useDispatch();
  const [quotationId, setQuotationId] = useState("");
  console.log("response response quotationId", quotationId);

  useEffect(() => {
    dispatch(setCurrentPageTitle("Add Lead"));
    dispatch(setcurrentLeadID(quotationId));
  }, [dispatch, quotationId]);

  const name = localStorage.getItem("name");
  const lastName = localStorage.getItem("lastName");
  const email = localStorage.getItem("email");
  const [AssignedPeople, SetAssignedPeople] = useState([]);
  const [, setEmployeesfinalList] = useState([]);
  const [Category] = useState("");
  const [LeadReports, setLeadReports] = useState([]);

  const employeeslist = useSelector((state) => state.employees.employees);
  const { leads } = useSelector((state) => state.leads);

  const currentEmployee = employeeslist?.find((emp) => emp.EmpEmail === email) ?? null;
  const hasNoFeatureConfig = !currentEmployee || !Array.isArray(currentEmployee?.featureAccess) || currentEmployee.featureAccess.length === 0;
  const addLeadAccessLevel = getFeatureAccessLevel(currentEmployee, "ADD LEAD");
  const downloadTemplateAccessLevel = getFeatureAccessLevel(currentEmployee, "DOWNLOAD TEMPLATE");
  const importLeadsAccessLevel = getFeatureAccessLevel(currentEmployee, "IMPORT LEADS");
  const isViewOnly = !!currentEmployee && !hasNoFeatureConfig && addLeadAccessLevel && String(addLeadAccessLevel).trim().toUpperCase() === "VIEW ONLY";

  const normalizedDownloadTemplateAccessLevel = String(downloadTemplateAccessLevel || "FULL ACCESS").trim().toUpperCase();
  const normalizedImportLeadsAccessLevel = String(importLeadsAccessLevel || "FULL ACCESS").trim().toUpperCase();
  const canShowDownloadTemplate = hasNoFeatureConfig || normalizedDownloadTemplateAccessLevel !== "NO ACCESS";
  const canShowImportLeads = hasNoFeatureConfig || normalizedImportLeadsAccessLevel !== "NO ACCESS";
  const isDownloadTemplateViewOnly = !hasNoFeatureConfig && normalizedDownloadTemplateAccessLevel === "VIEW ONLY";
  const isImportLeadsViewOnly = !hasNoFeatureConfig && normalizedImportLeadsAccessLevel === "VIEW ONLY";

  useEffect(() => {
    dispatch(fetchLeads());
    dispatch(fetchCompanyProfiles());
    dispatch(fetchEmployees());
  }, [dispatch]);

  useEffect(() => {
    const refreshHourlyRates = () => {
      dispatch(fetchSalesHourlyRates());
    };

    refreshHourlyRates();
    window.addEventListener("focus", refreshHourlyRates);
    window.addEventListener("pageshow", refreshHourlyRates);
    window.addEventListener("sales-hourly-rates-updated", refreshHourlyRates);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshHourlyRates();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", refreshHourlyRates);
      window.removeEventListener("pageshow", refreshHourlyRates);
      window.removeEventListener(
        "sales-hourly-rates-updated",
        refreshHourlyRates
      );
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch]);

  useEffect(() => {
    if (leads) {
      setLeadReports(leads);
    }
    if (employeeslist) {
      setEmployeesfinalList(employeeslist);
    }
  }, [leads, employeeslist]);

  const [isLoading, SetisLoading] = useState(false);
  const [LeadDate, setLeadDate] = useState(new Date());

  const parseTypedDate = (value, format) => {
    if (!value) return null;
    let day, month, year;
    if (format === "MM-dd-yyyy") {
      [month, day, year] = value.split("-");
    } else if (format === "dd-MM-yyyy") {
      [day, month, year] = value.split("-");
    } else {
      return null;
    }
    const parsed = new Date(year, month - 1, day);
    return isNaN(parsed) ? null : parsed;
  };

  const [ClientName, setClientName] = useState("");
  const [TypeService, setSelectedServices] = useState([]);
  const [LeadType, setLeadType] = useState("");
  const [AssignedGroup, setAssignedGroup] = useState("");
  const [selectedServiceTypes, setSelectedServiceTypes] = useState([]);
  const [QuotedValue, setQuotedValue] = useState("");
  const [ProjectName, setProjectName] = useState("");
  const [Reference, setReference] = useState("");
  const [ClientPhone, setClientPhone] = useState("");
  const [ClientContactName, setClientContactName] = useState("");
  const [ClientEmail, setClientEmail] = useState("");
  const [Status, setStatus] = useState("");
  const [Source, setSource] = useState("");
  const [FollowupDate, setFollowupDate] = useState(null);
  const [Probability, setProbability] = useState("");
  const [comments, setComments] = useState("");
  const [showSourceDropdown, setShowSourceDropdown] = useState("");
  const [showGroupDropdown, setShowGroupDropdown] = useState("");
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [showLeadTypeDropdown, setShowLeadTypeDropdown] = useState("");
  const [showStatusDropdown, setShowStatusDropdown] = useState("");
  const [showProbabilityDropdown, setShowProbabilityDropdown] = useState("");
  const [showCategoryDropdown, setShowCategoryDropdown] = useState("");
  const [SelectedCategory, setSelectedCategory] = useState("");
  const [fileNames, setFileNames] = useState([]);
  const dropdownRefSource = useRef(null);
  console.log("date lead LeadDate", LeadDate);
  console.log("date lead FollowupDate", FollowupDate);

  const quotationIdRef = useRef(quotationId);
  const firstLettersRef = useRef({ group: "", clientName: "", projectName: "" });
  
  useEffect(() => {
    quotationIdRef.current = quotationId;
  }, [quotationId]);

  const handleSendLeadID = useCallback(async (forceRegenerate = false) => {
    // Extract first letters only
    const firstLetterGroup = AssignedGroup ? AssignedGroup.trim().charAt(0).toUpperCase() : "";
    const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
    const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

    // Only proceed if all three fields have at least one character
    if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;
    
    const currentQuotationId = quotationIdRef.current;
    const currentFirstLetters = firstLettersRef.current;
    
    // Check if first letters have changed
    const firstLettersChanged = 
      currentFirstLetters.group !== firstLetterGroup ||
      currentFirstLetters.clientName !== firstLetterClient ||
      currentFirstLetters.projectName !== firstLetterProject;

    // If first letters haven't changed and we already have an ID, don't call API
    if (!forceRegenerate && !firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
      return;
    }

    try {
      // Delete old ID if it exists and first letters changed
      if (firstLettersChanged && currentQuotationId && currentQuotationId.length > 5) {
        try {
          await dispatch(
            deleteLeadId({
              generatedLeadId: currentQuotationId,
            })
          ).unwrap();
        } catch (error) {
          console.error("Delete Lead ID failed", error);
        }
        setQuotationId("");
        quotationIdRef.current = "";
      }

      // Update the first letters ref
      firstLettersRef.current = {
        group: firstLetterGroup,
        clientName: firstLetterClient,
        projectName: firstLetterProject,
      };

      // Call API with only first letters
      const response = await dispatch(
        generateLeadId({
          group: firstLetterGroup,
          clientName: firstLetterClient,
          projectName: firstLetterProject,
        })
      ).unwrap();
      setQuotationId(response.quotationId);
      quotationIdRef.current = response.quotationId;
    } catch (error) {
      console.error("Generate Lead ID failed", error);
    }
  }, [AssignedGroup, ClientName, ProjectName, dispatch]);

  const projectNameRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        projectNameRef.current &&
        !projectNameRef.current.contains(event.target) &&
        AssignedGroup &&
        ClientName &&
        ProjectName
      ) {
        handleSendLeadID();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [AssignedGroup, ClientName, ProjectName, handleSendLeadID]);

  useEffect(() => {
    // Extract first letters only
    const firstLetterGroup = AssignedGroup ? AssignedGroup.trim().charAt(0).toUpperCase() : "";
    const firstLetterClient = ClientName ? ClientName.trim().charAt(0).toUpperCase() : "";
    const firstLetterProject = ProjectName ? ProjectName.trim().charAt(0).toUpperCase() : "";

    // Only proceed if all three fields have at least one character
    if (!firstLetterGroup || !firstLetterClient || !firstLetterProject) return;

    const currentFirstLetters = firstLettersRef.current;
    
    // Check if first letters have changed
    const firstLettersChanged = 
      currentFirstLetters.group !== firstLetterGroup ||
      currentFirstLetters.clientName !== firstLetterClient ||
      currentFirstLetters.projectName !== firstLetterProject;

    // Only call API if first letters have changed
    if (firstLettersChanged) {
      handleSendLeadID(true);
    }
  }, [AssignedGroup, ClientName, ProjectName, handleSendLeadID]);


  const handleDeleteLeadID = useCallback(async () => {
    if (!quotationId) return;
    try {
      dispatch(
        deleteLeadId({
          generatedLeadId: quotationId,
        })
      );
      setQuotationId("");
    } catch (error) {
      console.error("Generate Lead ID failed", error);
    }
  }, [dispatch, quotationId]);

  

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefSource.current &&
        !dropdownRefSource.current.contains(event.target)
      ) {
        setShowSourceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefGroup = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefGroup.current &&
        !dropdownRefGroup.current.contains(event.target)
      ) {
        setShowGroupDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefService = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefService.current &&
        !dropdownRefService.current.contains(event.target)
      ) {
        setShowServiceDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefLeadType = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefLeadType.current &&
        !dropdownRefLeadType.current.contains(event.target)
      ) {
        setShowLeadTypeDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefStatus = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefStatus.current &&
        !dropdownRefStatus.current.contains(event.target)
      ) {
        setShowStatusDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRefProbability = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefProbability.current &&
        !dropdownRefProbability.current.contains(event.target)
      ) {
        setShowProbabilityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dropdownRefCategory = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefCategory.current &&
        !dropdownRefCategory.current.contains(event.target)
      ) {
        setShowCategoryDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const [GroupNames, setGroupNames] = useState([]);
  const [, setServiceTypes] = useState([]);
  const [Sources, setSources] = useState([]);
  const [LeadTypes, setLeadTypes] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const { employees } = useSelector((state) => state.employees);
  const { group } = useSelector((state) => state.group);
  const { serviceTypesRedux } = useSelector((state) => state.serviceTypesRedux);
  const { source } = useSelector((state) => state.source);
  const { leadTypesRedux } = useSelector((state) => state.leadTypesRedux);
  const { status } = useSelector((state) => state.status);

  useEffect(() => {
    setGroupNames(group);
    setServiceTypes(serviceTypesRedux);
    setSources(source);
    setLeadTypes(leadTypesRedux);
    setStatuses(status);
  }, [employees, group, serviceTypesRedux, source, leadTypesRedux, status]);

  useEffect(() => {
    dispatch(fetchServiceTypes());
    dispatch(fetchLeadTypes());
    dispatch(fetchGroups());
    dispatch(fetchSources());
    dispatch(fetchStatus());
    dispatch(fetchEmployees());
  }, [dispatch]);

  const LeadOwner = name + " " + lastName;
  const LeadOwnerEmail = email;

  const Submit = async (e) => {
    e.preventDefault();
    if (isViewOnly) return;
    if (
      !ClientName ||
      (Status !== "Won" && Status !== "Lost" && !FollowupDate) ||
      (Status === "Pending" &&
        !["High", "Medium", "Low"].includes(Probability)) ||
      !LeadDate ||
      !Source ||
      !ClientPhone ||
      !ClientContactName ||
      !TypeService.length ||
      !Status ||
      !QuotedValue
    ) {
      enqueueSnackbar("Please fill all the fields!", {
        variant: "error",
      });
      return;
    }
    const lastTenDigits = ClientPhone.slice(-10);
    if (/^0{10}$/.test(lastTenDigits)) {
      enqueueSnackbar("Enter Valid Phone Number!", {
        variant: "error",
      });
      return;
    }
    
    const numericPhone = ClientPhone.replace(/\D/g, ""); // Removes non-numeric characters
    console.log("Phone after cleanup:", numericPhone);

    // CORRECTED VALIDATION LOGIC
    if (loggedEmployee?.countrycode === "+1") {
      // US/Canada: Country code +1, total digits should be 11 (1 + 10)
      // OR just check that it's exactly 10 digits after removing the +1 country code
      const usPhoneWithoutCountryCode = numericPhone.replace(/^1/, '');
      if (usPhoneWithoutCountryCode.length !== 10) {
        enqueueSnackbar("Phone Number Must Be 10 Digits", {
          variant: "error",
        });
        return;
      }
    } else if (loggedEmployee?.countrycode === "+91") {
      // India: Country code +91, total digits should be 12 (91 + 10)
      // OR just check that it's exactly 10 digits after removing the +91 country code
      const indiaPhoneWithoutCountryCode = numericPhone.replace(/^91/, '');
      if (indiaPhoneWithoutCountryCode.length !== 10) {
        enqueueSnackbar("Phone Number Must Be 10 Digits", {
          variant: "error",
        });
        return;
      }
    } else {
      // Default validation for other country codes
      if (numericPhone.length < 10) {
        enqueueSnackbar("Phone Number Must Be At Least 10 Digits!", {
          variant: "error",
        });
        return;
      }
    }


    if (!emailRegex.test(ClientEmail)) {
      enqueueSnackbar("Please enter a valid email address!", {
        variant: "error",
      });
      return;
    }

    if (Source === "Reference" && !Reference) {
      enqueueSnackbar("Please enter Reference!", {
        variant: "error",
      });
      return;
    }

    SetisLoading(true);
    try {
      const selectedGroupObj = Array.isArray(group)
        ? group.find((g) => g?.newGroupName === AssignedGroup)
        : null;
      const groupid = selectedGroupObj?._id || selectedGroupObj?.id;

      const newLead = {
        ClientName,
        ClientEmail,
        ProjectName,
        LeadDate,
        ClientPhone,
        QuotedValue,
        ClientContactName,
        Status,
        Source,
        TypeService,
        AssignedGroup,
        groupid,
        LeadType,
        FollowupDate,
        Probability,
        Reference,
        comments,
        AssignedPeople,
        LeadOwner,
        LeadOwnerEmail,
        quotationId,
        SalesPersonStatus: "project requested",
      };
      const response = await dispatch(addLead(newLead)).unwrap();
      enqueueSnackbar("Lead Added Successfully!", {
        variant: "success",
      });
      navigate(`/dashboard/leadreport`);
      const data = response.lead; // Directly accessing the lead object
      await handleFileUpload(fileRefValue, data._id); // Use `data.id` (which is 243)
      setClientName("");
      setLeadDate("");
      setClientPhone("");
      setClientContactName("");
      setStatus("");
      setClientEmail("");
      setProjectName("");
      setQuotedValue("");
      setSelectedServices([]);
      setAssignedGroup("");
      setLeadType("");
      setFollowupDate("");
      setProbability("");
      setSource("");
      setReference("");
      setComments("");
      dispatch(fetchLeads());
      SetAssignedPeople([]);
      setSelectedCategory("");
      // setAssignedPeopleEmail([]);
    } catch (error) {
      console.error("Error:", error);

      let errorMessage =
        error?.error || // For rejectWithValue
        error?.response?.data?.error || // Fallback for direct axios
        error?.message ||
        "Something went wrong. Please try again.";

      // REFACTORED: Handle duplicate errors - show clear message based on error type
      if (
        errorMessage.includes("exact Project Name, Client Name, and Group combination already exists") ||
        errorMessage === "A lead with this exact Project Name, Client Name, and Group combination already exists. Please use a different Group if you want to create a duplicate Project Name and Client Name."
      ) {
        // This is the correct validation - exact duplicate (all three match)
        errorMessage = "A lead with this exact Project Name, Client Name, and Group combination already exists. Please use a different Group to create a duplicate Project Name and Client Name.";
      } else if (
        errorMessage?.toLowerCase().includes("project name") && 
        (errorMessage?.toLowerCase().includes("already exist") || 
         errorMessage?.toLowerCase().includes("duplicate") ||
         errorMessage?.includes("E11000")) // MongoDB duplicate key error code
      ) {
        // This indicates MongoDB unique index is still blocking - needs to be removed
        errorMessage = "Project name already exists. The database index needs to be removed. Please run: cd Backend && node forceRemoveIndex.js, then restart the backend server.";
      }

      enqueueSnackbar(errorMessage, {
        variant: "error",
      });
    } finally {
      SetisLoading(false);
      dispatch(setcurrentLeadID());
    }
  };

  const Cancel = (e) => {
    e.preventDefault();
    setClientName("");
    setClientEmail("");
    setLeadDate("");
    setClientPhone("");
    setClientContactName("");
    setStatus("");
    setProjectName("");
    setQuotedValue("");
    setSelectedServices([]);
    setLeadType("");
    setAssignedGroup("");
    setSource("");
    setFollowupDate("");
    setProbability("");
    setReference("");
    setComments("");
    SetAssignedPeople([]);
    setSelectedCategory("");
    setCurrentFileName("No File Selected"); // Clear file name
    handleDeleteLeadID();
    navigate(`/dashboard/leadreport`);
    dispatch(setcurrentLeadID());
    // Clear the file input manually
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleSourceChange = (source) => {
    const value = source;
    setSource(value);
    setShowSourceDropdown(false);
  };

  const handleGroupChange = (Group) => {
    const value = Group;
    setAssignedGroup(value);
    setShowGroupDropdown(false);
  };

  const handleServiceChange = (service) => {
    setSelectedServices((prevSelected) => {
      if (prevSelected.includes(service)) {
        // Unselect if already selected
        return prevSelected.filter((s) => s !== service);
      } else {
        return [...prevSelected, service];
      }
    });
  };

  const handleLeadTypeChange = (Leadtype) => {
    const value = Leadtype;
    setLeadType(value);
    setShowLeadTypeDropdown(false);
  };

  const handleStatusChange = (status) => {
    const value = status;
    setStatus(value);
    setShowStatusDropdown(false);
    if (value !== "Pending") {
      setProbability("");
    }
  };

  const handleProbabilityChange = (Probability) => {
    const value = Probability;
    setProbability(value);
    setShowProbabilityDropdown(false);
  };

  const fileInputRef = useRef(null);
  const [fileRefValue, setFileRef] = useState();
  const [currentFileName, setCurrentFileName] = useState("No File Selected");

  const handleFileChange = (event) => {
    if (isViewOnly) return;
    if (!event || !event.target || !event.target.files) return; // Prevents errors

    const file = event.target.files[0]; // Get the file from input

    if (!file) return;

    setCurrentFileName(file.name);

    const maxSize = 2 * 1024 * 1024; // 2MB in bytes
    const allowedFormats = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];

    if (!allowedFormats.includes(file.type)) {
      enqueueSnackbar("Only PDF and DOC files are allowed", {
        variant: "error",
      });
      event.target.value = ""; // Clear the file input
      setCurrentFileName("No File Selected"); // Clear the file input
      return;
    }

    if (file.size > maxSize) {
      enqueueSnackbar("File size exceeds 2MB! Please upload a smaller file.", {
        variant: "error",
      });
      event.target.value = "";
      setCurrentFileName("No File Selected");
      return;
    }

    enqueueSnackbar("File Uploaded Successfully!", {
      variant: "success",
    });
    setShowModal(false);
    setFileRef(event);
    setCurrentFileName(file.name);
  };

  const handleFileUpload = async (event, id, Category) => {
    if (!fileNames.length) {
      return;
    }

    const uploadDate = new Date().toISOString().slice(0, 10); // "2024-07-11"
    const formData = new FormData();

    // Append the common fields
    formData.append("leadId", id);
    formData.append("uploadDate", uploadDate);

    // Append each category and file separately
    fileNames.forEach((file) => {
      formData.append("selectedCategory", file.selectedCategory);
      formData.append("files", file);
    });

    try {
      // const uploadedFile =
      await dispatch(uploadFile(formData)).unwrap(); // Use Redux thunk
      setCurrentFileName("");
    } catch (error) {
      enqueueSnackbar("Error occurred while uploading file", {
        variant: "error",
      });
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    if (FollowupDate && LeadDate) {
      const lead = new Date(LeadDate);
      const followup = new Date(FollowupDate);

      if (followup < lead) {
        enqueueSnackbar("Followup date must be after lead date.", {
          variant: "error",
        });
        setFollowupDate(null);
      }
    }
  }, [FollowupDate, LeadDate, enqueueSnackbar]);

  const [showModal, setShowModal] = useState(false);

  const closeFileUpload = () => {
    setShowModal(false);
  };

  const loggedEmployee = useLoggedUser();

  const { iso2: defaultCountry, onlyCountries: allowedCountries } =
    resolveCountryInputConfig({
      countrycode: loggedEmployee?.countrycode,
      region: loggedEmployee?.region,
    });

  return (
    <div className=" bg-[#f3f8f8] min-h-full">
      {isLoading ? (
        <AdminLoader isLoading={isLoading} />
      ) : (
        <>
          <div className="relative  justify-center top-2">
            <div className="pt-3">
              <div className="bg-white rounded-md p-2 ">
                <div className="flex justify-end align-middle items-center ">
                  {/* <div className="flex h-full text-sm align-top items-start p-2 rounded-md border shadow-md bg-gray-300">
                    L/O :- {LeadOwner}
                  </div> */}
                  <Multipleleadexport
                    canShowDownloadTemplate={canShowDownloadTemplate}
                    canShowImportLeads={canShowImportLeads}
                    isDownloadTemplateViewOnly={isDownloadTemplateViewOnly}
                    isImportLeadsViewOnly={isImportLeadsViewOnly}
                  />
                </div>

                <div>
                  <div
                    className="grid grid-cols-1 md:grid-cols-4 gap-4  "
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      className="pt-1  mb-4 "
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="date">
                        Lead Date
                        <span className="text-red-700 text-xl">*</span>
                      </label>
                      <DatePicker
                        wrapperClassName="w-full"
                        selected={LeadDate}
                        dateFormat={getDateFormat()}
                        placeholderText={getDatePlaceholder()}
                        maxDate={new Date()}
                        showPopperArrow={false}
                        disabled={isViewOnly}
                        onChange={(date) => {
                          if (!(date instanceof Date) || isNaN(date)) return;
                          if (date > new Date()) {
                            enqueueSnackbar("Future dates are not allowed", {
                              variant: "error",
                            });
                            return;
                          }
                          setLeadDate(date);
                        }}
                        onBlur={(e) => {
                          const parsed = parseTypedDate(
                            e.target.value,
                            getDateFormat
                          );
                          if (!parsed) return;

                          if (parsed > new Date()) {
                            enqueueSnackbar("Future dates are not allowed", {
                              variant: "error",
                            });
                            return;
                          }
                          setLeadDate(parsed);
                        }}
                        className={`border w-full border-gray-400 rounded-md p-2 shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      />
                    </div>

                    {/* Group */}
                    <div
                      className="pt-1 mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Source">
                        Group<span className=" text-red-700 text-xl">*</span>
                      </label>
                      <div className="w-full ">
                        <div
                          ref={dropdownRefGroup}
                          className="relative flex w-full  p-0 rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className={`absolute cursor-pointer right-0 border-r border-gray-400 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : ""}`}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowGroupDropdown(!showGroupDropdown);
                            }}
                          />
                          <button
                            type="button"
                            disabled={isViewOnly}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowGroupDropdown(!showGroupDropdown);
                            }}
                            className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {AssignedGroup ? (
                              AssignedGroup
                            ) : (
                              <p>Select Group</p>
                            )}
                          </button>

                          {showGroupDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              {[...GroupNames]
                                .sort((a, b) =>
                                  a.newGroupName.localeCompare(b.newGroupName)
                                )
                                .map((group) => (
                                  <div
                                    className="p-1 hover:bg-gray-200 cursor-pointer"
                                    onClick={() => {
                                      handleGroupChange(group.newGroupName);
                                      setSelectedServiceTypes(
                                        group.servicetype
                                      );
                                      setSelectedServices([]);
                                    }}
                                    key={group.id}
                                    value={group.newGroupName}
                                  >
                                    {group.newGroupName}
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Client Name */}
                    <div
                      className="pt-1  mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Client Name
                        <span className="text-red-700 text-xl">*</span>
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        placeholder="Enter Client Name"
                        value={ClientName}
                        disabled={isViewOnly}
                        onChange={(e) => {
                          let value = e.target.value;
                          const filteredValue = value.replace(
                            /[^a-zA-Z0-9!@#$%*_\s-]/g,
                            ""
                          );
                          setClientName(filteredValue);
                        }}
                      />
                    </div>

                    {/* Project Name */}
                    <div
                      ref={projectNameRef}
                      className="pt-1 mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Project Name
                        <span className="text-red-700 text-xl">*</span>
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        placeholder="Enter Project Name"
                        value={ProjectName}
                        disabled={isViewOnly}
                        onChange={(e) => {
                          let value = e.target.value;
                          const filteredValue = value.replace(
                            /[^a-zA-Z0-9!@#$%*_\s-]/g,
                            ""
                          );
                          setProjectName(filteredValue);
                        }}
                      />
                    </div>
                  </div>

                  <div
                    className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {/* Type of Service */}
                    <div
                      className=" mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Source">
                        Type of Service
                        <span className="text-red-700 text-xl">*</span>
                      </label>
                      <div className=" bg-white">
                        <div
                          ref={dropdownRefService}
                          className="relative flex  p-0  rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className={`absolute cursor-pointer right-2 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : ""}`}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowServiceDropdown(!showServiceDropdown);
                            }}
                          />

                          <button
                            type="button"
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowServiceDropdown(!showServiceDropdown);
                            }}
                            disabled={isViewOnly || selectedServiceTypes.length === 0}
                            className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {selectedServiceTypes.length === 0 ? (
                              <span className="text-black">
                                No Service Type
                              </span>
                            ) : TypeService.length > 0 ? (
                              <div className="flex overflow-hidden gap-1">
                                {TypeService.map((service) => (
                                  <span
                                    key={service}
                                    className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs"
                                  >
                                    {service}
                                  </span>
                                ))}
                              </div>
                            ) : (
                              <span className="">Select Service Type</span>
                            )}
                          </button>

                          {showServiceDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full left-0 p-1 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              {selectedServiceTypes.map((serviceType) => {
                                const isSelected =
                                  TypeService.includes(serviceType);
                                return (
                                  <div
                                    key={serviceType}
                                    className={`p-1 cursor-pointer ${
                                      isSelected
                                        ? "bg-blue-100 font-semibold"
                                        : "hover:bg-gray-200"
                                    }`}
                                    onClick={() =>
                                      handleServiceChange(serviceType)
                                    }
                                  >
                                    {serviceType}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Quoted Value */}
                    <div
                      className=" mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Quoted Value
                        <span className="text-red-700 text-xl">*</span> ({currency})
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        placeholder="Enter Quoted Value"
                        inputMode="numeric"
                        maxLength={12}
                        pattern="[0-9]*"
                        value={USAComma(QuotedValue)}
                        disabled={isViewOnly}
                        onChange={(e) =>
                          setQuotedValue(
                            e.target.value
                              .split(".")[0]
                              .replace(/,/g, "")
                              .replace(/\D/g, "")
                          )
                        }
                      />
                    </div>

                    {/* Source */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Source">
                        Source<span className="text-red-700 text-xl">*</span>
                      </label>
                      <div className=" bg-white">
                        <div
                          ref={dropdownRefSource}
                          className="relative flex  p-0  rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className={`absolute cursor-pointer right-2 m-auto ${isViewOnly ? "cursor-not-allowed" : ""}`}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowSourceDropdown(!showSourceDropdown);
                            }}
                          />

                          <button
                            type="button"
                            disabled={isViewOnly}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowSourceDropdown(!showSourceDropdown);
                            }}
                            className={`border w-full bg-white border-gray-400 rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {Source ? Source : <p>Select Source</p>}
                          </button>

                          {showSourceDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              {[...Sources]
                                .sort((a, b) =>
                                  a.newSource.localeCompare(b.newSource)
                                )
                                .map((Sourc) => (
                                  <div
                                    className="p-1 hover:bg-gray-200 cursor-pointer"
                                    onClick={() =>
                                      handleSourceChange(Sourc.newSource)
                                    }
                                    key={Sourc.id}
                                    value={Sourc.newSource}
                                  >
                                    {Sourc.newSource}
                                  </div>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Reference */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Reference
                        {Source === "Reference" ? (
                          <span className="text-red-700 text-xl">*</span>
                        ) : (
                          <span className="text-red-700 text-xl"></span>
                        )}
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${
                          Source !== "Reference" || isViewOnly ? "bg-gray-200" : ""
                        } ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        placeholder="Enter Reference"
                        maxLength={30}
                        value={Source === "Reference" ? Reference : ""}
                        onChange={(e) => {
                          let value = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            ""
                          ); // Allows only letters and spaces
                          value =
                            value.charAt(0).toUpperCase() + value.slice(1); // Capitalizes the first letter
                          setReference(value);
                        }}
                        disabled={isViewOnly || Source !== "Reference"}
                      />
                    </div>
                  </div>

                  <div
                    className="grid grid-cols-1 md:grid-cols-4 gap-4 "
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {/* Contact Person */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Contact Person
                        <span className="text-red-700 text-xl">*</span>
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        maxLength={30}
                        placeholder="Enter Person Name"
                        value={ClientContactName}
                        disabled={isViewOnly}
                        onChange={(e) => {
                          let value = e.target.value.replace(
                            /[^a-zA-Z\s]/g,
                            ""
                          ); // Allows only letters and spaces
                          value =
                            value.charAt(0).toUpperCase() + value.slice(1); // Capitalizes the first letter
                          setClientContactName(value);
                        }}
                      />
                    </div>

                    {/* Email ID */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="email">
                        Email ID<span className="text-red-700 text-xl">*</span>
                      </label>
                      <input
                        className={`border w-full border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        type="text"
                        placeholder="Enter Email ID"
                        value={ClientEmail}
                        disabled={isViewOnly}
                        onChange={(e) => setClientEmail(e.target.value)}
                      />
                    </div>

                    {/* Mobile Number */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Name">
                        Mobile Number
                        <span className="text-red-700 text-xl">*</span>
                      </label>

                      <PhoneInput
                        country={defaultCountry}
                        countryCodeEditable={false}
                        disableDropdown={true}
                        disableCountryGuess={true}
                        value={String(ClientPhone)}
                        onChange={(value) => setClientPhone(value)}
                        enableSearch={true}
                        disabled={isViewOnly}
                        onlyCountries={allowedCountries}
                        preferredCountries={[]}
                        inputProps={{
                          required: true,
                          disabled: isViewOnly,
                          className: `w-full h-10 border text-sm border-gray-400 outline-0 rounded overflow-hidden shadow-md p-2 pl-10 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`,
                          style: {
                            fontFamily:
                              "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
                          },
                        }}
                      />
                    </div>

                    {/* Lead Type */}
                    <div
                      className="mb-4"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Source">
                        Lead Type<span className="text-red-700 text-xl">*</span>
                      </label>
                      <div className=" bg-white">
                        <div
                          ref={dropdownRefLeadType}
                          className="relative flex  p-0  rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className={`absolute cursor-pointer right-2 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : ""}`}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowLeadTypeDropdown(!showLeadTypeDropdown);
                            }}
                          />

                          <button
                            type="button"
                            disabled={isViewOnly}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowLeadTypeDropdown(!showLeadTypeDropdown);
                            }}
                            className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {LeadType ? LeadType : <p>Select Lead Type</p>}
                          </button>

                          {showLeadTypeDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              {LeadTypes.map((LeadTyp) => (
                                <div
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                  onClick={() =>
                                    handleLeadTypeChange(LeadTyp.LeadType)
                                  }
                                  key={LeadTyp.id}
                                  value={LeadTyp.LeadType}
                                >
                                  {LeadTyp.LeadType}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="grid grid-cols-1 md:grid-cols-4 gap-4"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {/* Status */}
                    <div
                      className="pt-1"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Status">
                        Status<span className="text-red-700 text-xl">*</span>
                      </label>
                      <div className=" bg-white">
                        <div
                          ref={dropdownRefStatus}
                          className="relative flex  p-0  rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            color="white"
                            className={`absolute cursor-pointer right-2 m-auto bg-white ${isViewOnly ? "cursor-not-allowed" : ""}`}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowStatusDropdown(!showStatusDropdown);
                            }}
                          />

                          <button
                            type="button"
                            disabled={isViewOnly}
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowStatusDropdown(!showStatusDropdown);
                            }}
                            className={`border w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {Status ? Status : <p>Select Status</p>}
                          </button>

                          {showStatusDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full p-1 left-0 w-full cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              {statuses.map((statuse) => (
                                <div
                                  className="p-1 hover:bg-gray-200 cursor-pointer"
                                  onClick={() =>
                                    handleStatusChange(statuse.status)
                                  }
                                  key={statuse.id}
                                  value={statuse.status}
                                >
                                  {statuse.status}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Probability */}
                    <div
                      className="pt-1"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <label className="block" htmlFor="Status">
                        Probability{" "}
                        {Status === "Pending" ? (
                          <span className="text-red-700 text-xl">*</span>
                        ) : (
                          <span className="text-red-700 text-xl"></span>
                        )}
                      </label>
                      <div className=" bg-white">
                        <div
                          ref={dropdownRefProbability}
                          className="relative flex  p-0  rounded-xl align-middle items-center"
                        >
                          <ExpandMoreIcon
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowProbabilityDropdown(
                                !showProbabilityDropdown
                              );
                            }}
                            color="white"
                            className={`absolute cursor-pointer right-2 m-auto ${isViewOnly ? "cursor-not-allowed" : ""}`}
                          />

                          <button
                            type="button"
                            onClick={() => {
                              if (isViewOnly) return;
                              setShowProbabilityDropdown(
                                !showProbabilityDropdown
                              );
                            }}
                            disabled={isViewOnly || Status !== "Pending"}
                            className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${
                              Status !== "Pending" || isViewOnly ? "bg-gray-200" : ""
                            } ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                          >
                            {Probability ? (
                              Probability
                            ) : (
                              <p>Select Probability</p>
                            )}
                          </button>

                          {showProbabilityDropdown && (
                            <div
                              style={{ zIndex: 9999 }}
                              className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                            >
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() => handleProbabilityChange("High")}
                              >
                                High
                              </div>
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() =>
                                  handleProbabilityChange("Medium")
                                }
                              >
                                Medium
                              </div>
                              <div
                                className="p-1 hover:bg-gray-200 cursor-pointer"
                                onClick={() => handleProbabilityChange("Low")}
                              >
                                Low
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Next Follow-up Date */}
                    <div
                      className="pt-1"
                      style={{ width: "22.5%", height: "4%" }}
                    >
                      <label className="block" htmlFor="date">
                        {Status === "Won" || Status === "Lost" ? (
                          ""
                        ) : (
                          <>
                            Next Follow-up Date{" "}
                            <span className="text-red-700 text-xl">*</span>
                          </>
                        )}
                      </label>

                      {Status !== "Won" && Status !== "Lost" && (
                        // <DatePicker
                        //   selected={FollowupDate}
                        //   onChange={(date) => setFollowupDate(date)}
                        //   dateFormat={getDateFormat()}
                        //   placeholderText={getDatePlaceholder()}
                        //   minDate={
                        //     LeadDate
                        //       ? new Date(
                        //         new Date(LeadDate).setDate(
                        //           new Date(LeadDate).getDate() + 1
                        //         )
                        //       )
                        //       : null
                        //   }
                        //   customInput={
                        //     <InputMask
                        //       mask="99-99-9999"
                        //       placeholder={getDatePlaceholder()}
                        //       className="border w-full pr-16 border-gray-400 rounded-md p-2 overflow-hidden shadow-md outline-none"
                        //     />
                        //   }
                        //   onChangeRaw={(e) => {
                        //     const inputValue = e.target.value;
                        //     if (!inputValue || inputValue.length < 10) return;

                        //     const [month, day, year] = inputValue.split("-");
                        //     const parsedDate = new Date(`${year}-${month}-${day}`);
                        //     if (parsedDate instanceof Date && !isNaN(parsedDate)) {
                        //       setFollowupDate(parsedDate);
                        //     }
                        //   }}
                        // />

                        <DatePicker
                          selected={FollowupDate}
                          dateFormat={getDateFormat()}
                          placeholderText={getDatePlaceholder()}
                          minDate={LeadDate}
                          showPopperArrow={false}
                          disabled={isViewOnly}
                          onChange={(date) => {
                            if (!(date instanceof Date) || isNaN(date)) return;

                            if (LeadDate && date < LeadDate) {
                              enqueueSnackbar(
                                "Follow-up date must be after Lead Date",
                                { variant: "error" }
                              );
                              return;
                            }

                            setFollowupDate(date);
                          }}
                          onBlur={(e) => {
                            const parsed = parseTypedDate(
                              e.target.value,
                              getDateFormat
                            );
                            if (!parsed) return;

                            if (LeadDate && parsed < LeadDate) {
                              enqueueSnackbar(
                                "Follow-up date must be after Lead Date",
                                { variant: "error" }
                              );
                              return;
                            }
                            setFollowupDate(parsed);
                          }}
                          className={`border w-full pr-16 border-gray-400 rounded-md p-2 shadow-md outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        />
                      )}
                    </div>

                    <div
                      className="pt-1.5 flex gap-2"
                      style={{ width: "22%", height: "4%" }}
                    >
                      <FileUploadAddLead
                        setFileNames={setFileNames}
                        fileNames={fileNames}
                        SelectedCategory={SelectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        projectName={ProjectName}
                      />
                      {/* {packageData === "CRM" && (

                        <div title="Generate Quote" className="flex flex-col justify-end pb-3">
                          {auth === "L3" && ProjectName && (
                            <TextSnippetIcon

                              className="w-5 h-5 cursor-pointer"
                              onClick={() => {
                                setShowQuoteModal(true);
                                setselectedProject(ProjectName)
                                setselectedGroup(ProjectName)
                              }} />
                          )}
                        </div>
                      )} */}
                    </div>
                  </div>
                  <br></br>

                  {/* Comments */}
                  <div className="w-full flex">
                    <div className="w-1/2 pr-5">
                      <label className="block" htmlFor="comments">
                        Comments
                      </label>
                      <textarea
                        className={`border w-full border-gray-400 rounded-md p-4 overflow-hidden shadow-md outline-none resize-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                        placeholder="Enter Comments"
                        id="comments"
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        required={Status === "Pending"}
                        disabled={isViewOnly}
                        name="comments"
                        rows={2}
                      />
                    </div>

                    {showModal && (
                      <div
                        id="file-upload-popup"
                        className="fixed inset-0 flex justify-center items-center z-50 bg-opacity-50 bg-black"
                      >
                        <div className="min-w-[40%] max-w-[60%] bg-white  shadow-lg rounded-lg p-6">
                          <div className="flex justify-between items-center mb-6">
                            <h2 className="text-lg font-bold">Attachments</h2>
                            <button
                              onClick={closeFileUpload}
                              className="text-gray-500 hover:text-black border-gray-900"
                            >
                              Close
                            </button>
                          </div>
                          <div className="w-full  gap-5 mt-[-1rem] flex justify-between align-middle items-center">
                            <div className="pb-1 mb-3 w-1/2">
                              <label className="block" htmlFor="Status">
                                Category
                              </label>
                              <div className=" bg-white">
                                <div
                                  ref={dropdownRefCategory}
                                  className="relative flex  p-0  rounded-xl align-middle items-center"
                                >
                                  <ExpandMoreIcon
                                    color="white"
                                    className={`absolute cursor-pointer right-2 m-auto ${isViewOnly ? "cursor-not-allowed" : ""}`}
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      setShowCategoryDropdown(
                                        !showCategoryDropdown
                                      );
                                    }}
                                  />

                                  <button
                                    type="button"
                                    disabled={isViewOnly}
                                    onClick={() => {
                                      if (isViewOnly) return;
                                      setShowCategoryDropdown(
                                        !showCategoryDropdown
                                      );
                                    }}
                                    className={`border w-full border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                  >
                                    {Category ? Category : "Category"}
                                  </button>

                                  {showCategoryDropdown && (
                                    <div
                                      style={{ zIndex: 9999 }}
                                      className="absolute top-full left-0 w-full p-1 cursor-pointer max-h-96 overflow-y-auto bg-white text-sm border border-gray-300 shadow-lg flex flex-col gap-1"
                                    >
                                      <div
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                        onClick={() => {
                                          setSelectedCategory("Quote");
                                          setShowCategoryDropdown(
                                            !showCategoryDropdown
                                          );
                                        }}
                                      >
                                        Quote
                                      </div>
                                      <div
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                        onClick={() => {
                                          setSelectedCategory("Purchase Order");
                                          setShowCategoryDropdown(
                                            !showCategoryDropdown
                                          );
                                        }}
                                      >
                                        Purchase Order
                                      </div>
                                      <div
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                        onClick={() => {
                                          setSelectedCategory("Contract");
                                          setShowCategoryDropdown(
                                            !showCategoryDropdown
                                          );
                                        }}
                                      >
                                        Contract
                                      </div>
                                      <div
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                        onClick={() => {
                                          setSelectedCategory("Communication");
                                          setShowCategoryDropdown(
                                            !showCategoryDropdown
                                          );
                                        }}
                                      >
                                        Communication
                                      </div>
                                      <div
                                        className="p-1 hover:bg-gray-200 cursor-pointer"
                                        onClick={() => {
                                          setSelectedCategory("Miscellaneous");
                                          setShowCategoryDropdown(
                                            !showCategoryDropdown
                                          );
                                        }}
                                      >
                                        Miscellaneous
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="w-1/2 pl-3">
                              <div className="">
                                <label className="block" htmlFor="LeadType">
                                  Upload File
                                </label>

                                <div className="w-full flex justify-start gap-1 items-center p-1">
                                  <input
                                    type="file"
                                    id={`file-upload-${
                                      LeadReports.length + 1 || "from-addlead"
                                    }`}
                                    className="hidden"
                                    onChange={(e) => handleFileChange(e)}
                                    disabled={isViewOnly || !Category}
                                  />
                                  <label
                                    onClick={(e) => {
                                      if (isViewOnly) {
                                        e.preventDefault();
                                        return;
                                      }
                                      if (!Category) {
                                        e.preventDefault();
                                        enqueueSnackbar(
                                          "Please select a category.",
                                          {
                                            variant: "error",
                                          }
                                        );
                                      }
                                    }}
                                    htmlFor={`file-upload-${
                                      LeadReports.length + 1 || "from-addlead"
                                    }`}
                                    className={`bg-gray-800 text-xs text-white hover:text-black p-2 rounded-md cursor-pointer hover:bg-gray-300 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                                  >
                                    Upload File
                                  </label>

                                  <span className="">{currentFileName}</span>
                                </div>
                                <div className="flex gap-2 text-red-700">
                                  <p className="text-xs pl-2">
                                    (Please upload .pdf and .docx files only)
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="flex mt-8 gap-5 justify-start">
                    <button
                      onClick={Submit}
                      disabled={isViewOnly}
                      className={`py-2 px-7 overflow-hidden shadow-md rounded-lg ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-[#e32278] text-white"}`}
                    >
                      Confirm
                    </button>
                    <button
                      onClick={Cancel}
                      className="py-2 px-7 bg-black hover:bg-white hover:text-black border border-black overflow-hidden shadow-md text-white rounded-lg"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br />
          </div>
        </>
      )}
    </div>
  );
};

export default AddLead;
